<input-wrap
  *ngIf="
    opt.valueType == 'LIST' &&
    (opt.displayType == 'DROPDOWN' ||
      (drProfileSw &&
        (opt.displayType == 'SELECT_BUTTON' ||
          opt.displayType == 'SELECT_BUTTON_ICON')))
  "
  label="{{ label ? (drProfileSw ? opt.drPrefDescr : opt.text) : null }}"
  cssClass="l-cell-spread"
  [singleLine]="singleLine"
  [required]="opt.required && !drProfileSw"
  [customValidation]="opt.required ? opt.selectedValue != null : undefined"
>
  <p-select
    class="t-input--colored"
    [options]="opt.valueList"
    [(ngModel)]="opt.selectedValue"
    [placeholder]="'translate.general.choose' | translate"
    [optionLabel]="'text'"
    appendTo="body"
    (onChange)="onListValueChanged()"
    [disabled]="readOnly"
    [editable]="allowDropdownCustomInput()"
  >
    <ng-template pTemplate="selectedItem">
      <div class="opt-value" *ngIf="opt.selectedValue">
        <img
          *ngIf="opt.selectedValue.iconKey"
          [src]="getIcon(opt.selectedValue.iconKey)"
        />
        <div>{{ opt.selectedValue.text }}</div>
      </div>
    </ng-template>
    <ng-template let-row pTemplate="item">
      <div class="opt-value">
        <img *ngIf="row.iconKey" [src]="getIcon(row.iconKey)" />
        <div>{{ row.text }}</div>
      </div>
    </ng-template>
  </p-select>
  <clear-multi
    *ngIf="opt.selectedValue"
    (click)="opt.selectedValue = null"
  ></clear-multi>
</input-wrap>

<input-wrap
  *ngIf="
    opt.valueType == 'LIST' &&
    opt.displayType == 'SELECT_BUTTON' &&
    !drProfileSw
  "
  label="{{ label ? opt.text : null }}"
  cssClass="l-cell-spread "
  [singleLine]="singleLine"
  [required]="opt.required"
>
  <p-selectButton
    [options]="opt.valueList"
    [(ngModel)]="opt.selectedValue"
    optionLabel="text"
    [disabled]="readOnly"
    (onChange)="onListValueChanged()"
    [unselectable]="true"
  ></p-selectButton>
  <clear-multi
    *ngIf="opt.selectedValue"
    (click)="opt.selectedValue = null"
  ></clear-multi>
</input-wrap>

<input-wrap
  *ngIf="
    opt.valueType == 'LIST' &&
    opt.displayType == 'SELECT_BUTTON_ICON' &&
    !drProfileSw
  "
  label="{{ label ? opt.text : null }}"
  cssClass="l-cell-spread "
  [singleLine]="singleLine"
  [required]="opt.required"
>
  <p-selectbutton
    [options]="opt.valueList"
    [(ngModel)]="opt.selectedValue"
    optionLabel="text"
    [disabled]="readOnly"
    (onChange)="onListValueChanged()"
    [unselectable]="true"
  >
    <ng-template #item let-item>
      <!-- <img
        *ngIf="row.iconKey"
        [src]="getIcon(row.iconKey)"
        pTooltip="{{ row.text }}"
        tooltipPosition="bottom"
      /> -->
      <svg-icon
        *ngIf="item.iconKey"
        src="{{ getIcon(item.iconKey) }}"
        pTooltip="{{ item.text }}"
        tooltipPosition="bottom"
        [class.selected-icon]="item == opt.selectedValue"
        [applyClass]="true"
      ></svg-icon>
    </ng-template>
  </p-selectbutton>
  <clear-multi
    *ngIf="opt.selectedValue"
    (click)="opt.selectedValue = null"
  ></clear-multi>
</input-wrap>

<input-wrap
  *ngIf="opt.valueType == 'LIST' && opt.displayType == 'RADIO'"
  label="{{ label ? opt.text : null }}"
  cssClass="l-cell-spread "
  [singleLine]="singleLine"
  [required]="opt.required"
>
  <div class="radio-container">
    <div *ngFor="let value of opt.valueList" class="radio-row">
      <p-radioButton
        [inputId]="value.id"
        name="value.id"
        [value]="value"
        [(ngModel)]="opt.selectedValue"
        [disabled]="readOnly"
        (onClick)="onChange()"
        variant="filled"
      ></p-radioButton>
      <label [for]="value.id" class="ml-2">{{ value.text }}</label>
    </div>
  </div>
</input-wrap>

<input-wrap
  *ngIf="opt.valueType == 'TEXT'"
  label="{{ opt.text }}"
  cssClass="l-cell-spread "
  [singleLine]="singleLine"
  [required]="opt.required"
  (keyup)="validateTextInput($event)"
  pTooltip="{{ validationMsg }}"
  tooltipPosition="top"
>
  <input
    type="text"
    [(ngModel)]="opt.valueText"
    class="t-input t-input--colored"
    [class.invalid]="!valueValid"
    [disabled]="readOnly"
    (ngModelChange)="onChange()"
  />
</input-wrap>

<input-wrap
  *ngIf="opt.valueType == 'NUMERIC'"
  label="{{ opt.text }}"
  cssClass="l-cell-spread "
  [singleLine]="singleLine"
  [required]="opt.required"
>
  <input
    type="number"
    [(ngModel)]="opt.valueNum"
    class="t-input t-input--colored"
    (ngModelChange)="onChange()"
    (change)="
      opt.min && opt.valueNum < opt.min
        ? (opt.valueNum = opt.min)
        : opt.valueNum;
      opt.max && opt.valueNum > opt.max
        ? (opt.valueNum = opt.max)
        : opt.valueNum
    "
    [min]="opt.min"
    [max]="opt.max"
    [disabled]="readOnly"
  />
</input-wrap>

<input-wrap
  *ngIf="opt.valueType == 'BOOL'"
  label="{{ opt.text }}"
  class="checkbox-input"
  [singleLine]="singleLine"
  [required]="opt.required"
>
  <checkbox-wrap class="checkbox">
    <svg-icon *ngIf="opt.icon" src="{{ getIcon(opt.icon) }}"></svg-icon>

    <input
      type="checkbox"
      (ngModelChange)="onChange()"
      [(ngModel)]="opt.valueBool"
      [disabled]="readOnly"
    />
  </checkbox-wrap>
</input-wrap>
